import React, {Component} from 'react';
import InnerPage from '../../shared/InnerPage/InnerPage'
import {connect} from 'react-redux';
import Toolkit from '../../components/Toolkit/Toolkit';
import { withRouter } from 'react-router-dom';
import InfluencerMap  from '../../components/InfluencerMap/InfluencerMap';
import { ToastContainer, toast } from 'react-toastify';
import { getInfluencerMapGroups, addInfluencerMapGroups, editInfluencerMapGroups } from '../../store/actions/InfluencerMapActions';

class InfluencerMapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
      };
    }

    componentWillMount(){
      //this.props.getProjectsList();
    }

    componentWillReceiveProps(nextProps){
      
    }

    elementInfiniteLoad() {
      return (
        <div className='col-sm-12'>
          <div className='spinner3'>
            <div className='rect1'/>
            <div className='rect2'/>
            <div className='rect3'/>
            <div className='rect4'/>
            <div className='rect5'/>
          </div>
        </div>
      );
    }

    render() {
        return (
          <div>
            <div className="error-box">
              <ToastContainer
                position="top-right"
                type="success"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
              />
            </div>
            <InnerPage
              changeUserPassword={this.props.changeUserPassword}
              changePasswordResult={this.props.changePasswordResult}
              location={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 2]}
            >

              <InfluencerMap
                projectId={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1]}
                getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                getInfluencerMapGroupsFetching={this.props.getInfluencerMapGroupsFetching}
                addInfluencerMapGroups={this.props.addInfluencerMapGroups}
                addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                editInfluencerMapGroups={this.props.editInfluencerMapGroups}
              />

            </InnerPage>
            
          </div>
        )
    }
}

const mapStateToProps = (store, verify) => {
  return {
    getInfluencerMapGroupsData: store.influencerMap.getInfluencerMapGroupsData,
    getInfluencerMapGroupsFetching: store.influencerMap.getInfluencerMapGroupsFetching,
    addInfluencerMapGroupsData: store.influencerMap.addInfluencerMapGroupsData,
    
  }
};

const mapDispatchToProps = (dispatch) => ({
  getInfluencerMapGroups: (data) => dispatch(getInfluencerMapGroups(data)),
  addInfluencerMapGroups: (data) => dispatch(addInfluencerMapGroups(data)),
  editInfluencerMapGroups: (data) => dispatch(editInfluencerMapGroups(data)), 
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InfluencerMapContainer));



// WEBPACK FOOTER //
// ./src/containers/InfluencerMap/InfluencerMapContainer.js